<h1 mat-dialog-title>{{ 'LABEL.DELETE_CONFIRMATION' | translate }}</h1>
<div mat-dialog-content>
	<p>{{data}}</p>
</div>
<div mat-dialog-actions>
	<div style="margin-left: auto; margin-right: auto;">
		<button mat-button (click)="cancel()">{{ 'LABEL.CANCEL' | translate }}</button>
		<button mat-button (click)="confirm()">{{ 'LABEL.CONFIRM' | translate }}</button>
	</div>
</div>